var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msg-subscr-msanage" }, [
      _c("div", { staticClass: "hint block mb10" }, [
        _c("div", { staticClass: "title" }, [_vm._v("温馨提示")]),
        _vm._v(" "),
        _c("p", [_vm._v("检查：全部数据一起检查，数据较多的时候花费时间较长")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block mb10" }, [
        _c("p", [
          _vm._v(
            "检查并导入：全部数据一起检查并导入，数据较多的时候花费时间较长"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block" }, [
        _c("p", [_vm._v("导入excel文件的单元格格式推荐使用常规或文本")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-body mt10" }, [
        _c("ul", { staticClass: "native-table" }, [
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("列名")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-th", staticStyle: { width: "120px" } },
              [_vm._v("是否必填")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("其他要求")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-th" }, [_vm._v("不符合要求的结果")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("服务名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("服务标题")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("服务类型")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中选择")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("服务用途")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中选择")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("规格名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("规格说明")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("上门费(元)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("参考人工费(元)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("服务费(元)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("要求质保时长(天)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("要求响应时长(分钟)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("要求到达时长(分钟)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("要求维修时长(分钟)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("电话回询时限(分钟)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("配件名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("配件规格")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("价格下限(元)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("价格上限(元)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中编辑")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0145d7d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0145d7d2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servc/ServcFormatExpl.vue
// module id = 2022
// module chunks = 1